import React from 'react';
import styled from 'styled-components';

const UnderDevelopmentPage = ({ moduleName = 'This module', onBack, darkMode }) => {
  return (
    <Wrapper darkMode={darkMode}>
      <Card darkMode={darkMode}>
        <IconRow aria-hidden="true">🚧</IconRow>
        <Heading>Module Under Development</Heading>
        <Subtitle>
          The <strong>{moduleName}</strong> feature is currently being developed
          and will be available soon.
        </Subtitle>
        {typeof onBack === 'function' && (
          <BackButton onClick={onBack}>← Back</BackButton>
        )}
      </Card>
    </Wrapper>
  );
};

export default UnderDevelopmentPage;

const Wrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  background: ${({ darkMode }) => (darkMode ? '#0f1c14' : '#e7f2ec')};
`;

const Card = styled.div`
  background: ${({ darkMode }) => (darkMode ? '#1a2a20' : '#ffffff')};
  color: ${({ darkMode }) => (darkMode ? '#e7f2ec' : '#0f2713')};
  padding: 48px 56px;
  border-radius: 24px;
  border: 1px solid ${({ darkMode }) => (darkMode ? '#2c3d31' : '#d7e8de')};
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);
  text-align: center;
  max-width: 560px;
  width: 100%;
`;

const IconRow = styled.div`
  font-size: 64px;
  margin-bottom: 12px;
`;

const Heading = styled.h1`
  margin: 0 0 12px;
  font-size: clamp(22px, 4vw, 30px);
  font-weight: 800;
  color: #2e7d32;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

const Subtitle = styled.p`
  margin: 0 0 24px;
  font-size: 16px;
  line-height: 1.5;
  opacity: 0.85;
`;

const BackButton = styled.button`
  background: #2e7d32;
  color: #fff;
  border: none;
  padding: 10px 22px;
  border-radius: 999px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #1b5e20;
  }
`;
